module.exports = __webpack_public_path__ + "img/Harbin Station Concepts_Page_2.6058bc27.jpg";